import React from "react"
import style from "./SideBarRight.css"

export const SideBarRightLayout = ({children}) => {
    return <div className={style.layout}>
        {children}
    </div>
}

export const SideBarRightHead = ({children}) => {
    return <div>
        {children}
    </div>
}

export const SideBarRightInfo = ({children}) => {
    return <div className={style.info}>
        {children}
    </div>
}
export const SideBarRightHeadItem = ({isDisabled, isActive, icon, label, onClick}) => {
    const className = isDisabled
        ? style.item
        : (isActive ? style.itemActive : style.itemEnabled)

    const onClickLocal = () => {
        if (isDisabled) return
        onClick()
    }

    return <div className={className} onClick={onClickLocal}>
        <div>{icon}</div>
        <div>{label}</div>
    </div>
}

export const SideBarRightBody = ({children, isOpen}) => {
    return <div className={isOpen ? style.body : style.bodyClose}>
        {children}
    </div>
}

export const SideBarRightBody2Rows = ({children, isOpen}) => {
    return <div className={isOpen ? style.body : style.bodyClose}>
        <div className={style.twoRows}>
            {children}
        </div>
    </div>
}

export const SideBarRightSectionLabel10 = ({children, label}) => {
    return <div className={style.sectionLabel10}>
        {children || label}
    </div>
}

export const SideBarRightSectionLabel20 = ({children, label}) => {
    return <div className={style.sectionLabel20}>
        {children || label}
    </div>
}

export const SideBarRightBodyBlock = ({children}) => {
    return <div className={style.block}>
        {children}
    </div>
}


export const SideBarRightBodyBlockLabel = ({children, label}) => {
    return <div className={style.label}>
        {children || label}
    </div>
}

export const SideBarRightBodyBlockLabelHighlight = ({children, label}) => {
    return <span className={style.highlight}>
        {children || label}
    </span>
}